const sx = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "1rem",
  },
  paperContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    textAlign: "left",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  bookData: {
    padding: "10px",
    width: "100%",
  },
  typeTitle: {
    borderBottom: "1px solid",
    width: "100%",
    display: "flex",
    // justifyContent: "center",
    padding: "10px",
  },
};
export default sx;
